import { useContext, useEffect } from 'react';
import { ViewVideoContext } from '../context/View.video.context';

export const useSetCurrentWorkspace = () => {
  const {
    setCurrentWorkspaceUuid,
    workspaces
  } = useContext(ViewVideoContext);

  useEffect(() => {
    const currentWorkspace = workspaces?.find((w) => w.isActive);
    if (currentWorkspace) {
      setCurrentWorkspaceUuid(currentWorkspace.uuid);
    }
  }, []);
};
